import { HttpEventType } from '@angular/common/http';
import { Component, HostListener, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import moment from 'moment';
import readXlsxFile from 'read-excel-file';
import { filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { InternalOrderEnums } from 'src/app/enum/internal-order-enums';
import { ClassMaintenanceOrderEnum } from 'src/app/enum/maintenance-order-enum';
import { UserModel } from 'src/app/models/authentication/user.model';
import { InternalOrderImportModel } from 'src/app/models/imports/internal-order-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { InternalOrderService } from 'src/app/services/shopping/internal-order.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-internal-order-import',
  templateUrl: './internal-order-import.component.html',
  styleUrls: ['./internal-order-import.component.scss'],
  standalone: false
})
export class InternalOrderImportComponent implements OnInit, OnDestroy {

  private readonly companyService = inject(CompanyService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly headerService = inject(HeaderService);
  private readonly internalOrderService = inject(InternalOrderService);
  private readonly router = inject(Router);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly title = inject(Title);
  private readonly userAuthenticatedService = inject(UserAuthenticatedService);
  private readonly windowService = inject(WindowService)

  companyCode: number | null = null;
  companyId: number;
  eventFile: any;
  errorInternalOrder: number = 0;
  filters: ColumnResponseModel[] = [];
  formImport: FormGroup = new FormGroup({});
  isOpened: string | undefined = undefined;
  listCompanies: any[] = [];
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  internalOrderAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>();
  nameWindow: string = 'Importación Pedidos Internos';
  nameFile: string = 'Ningún archivo seleccionado.';
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  url: string = "internal-order-import";
  userAuthenticated: UserModel = new UserModel();
  visibleTxt: boolean = false;

  ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem(this.url);
    if (filters) this.filters = JSON.parse(filters);
    this.headerService.setTitle(this.nameWindow);
    this.getPermission();
    this.validateForm();
    this.getAllLists();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  downloadErrorsTxt() {
    if (!this.internalOrderAlerts || this.internalOrderAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.internalOrderService.exportImportErrors(this.internalOrderAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionPedidosInternos_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  downloadGuideImport() {
    this.internalOrderService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaPedidosInternos.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  async getAllLists() {
    try {
      const [companies] = await Promise.all([
        firstValueFrom(this.companyService.getAllCompaniesForSelectAsync()),

      ]);
      this.listCompanies = companies;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getCompany(companyId: number | null) {
    if (companyId != null && companyId != 0) {
      this.companyId = companyId;
      const company = this.listCompanies.find(x => x.value == companyId);
      this.companyCode = company.code;
    } else {
      this.companyCode = null;
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos por tipo de impuesto.', error);
    }
    this.getPermissionsForUserByWindow();
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
  }

  importInternalOrder() {
    this.internalOrderAlerts = [];
    this.errorInternalOrder = 0;
    this.visibleTxt = false;
    Object.keys(this.formImport.controls).forEach(key => {
      const control = this.formImport.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formImport.valid) {
      let isOk: boolean = true;
      const input = document.getElementById('fileImport') as any;
      const rowsImport = new Array<InternalOrderImportModel>();
      let row: InternalOrderImportModel;
      let counter: number = 1, branchCode: number = 0, internalOrderNumber: number = 0, alterNumber: number | null = null, internalOrderDate: Date = new Date(),
        responsible: string = "", observation: string | null = null, internalOrderState: number = 0, maintenanceOrderClass: number | null = null,
        maintenanceOrderNumber: number | null = null, articleCode: number = 0, quotationNumber: number | null = null, swUrgent: boolean = false, quantity: number = 0;
      if (input.files[0]) {
        readXlsxFile(input.files[0]).then(async (rows) => {
          if (rows.length <= 1) {
            this.toastHandlerService.showToast('warning', `El archivo ingresado no tiene registros para importar.`);
            return;
          }
          rows.splice(0, 1);

          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError: boolean = false;

            //A. Código Compañía
            const companyCode = parseFloat(element[0] as string);
            if (isNaN(companyCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna A. El código de la Compañía no es válido.`;
              this.internalOrderAlerts.push(alert);
              rowHasError = true;
            } else {
              if (companyCode != this.companyCode) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna A. La Compañía del archivo no es igual a la Compañía seleccionada.`;
                this.internalOrderAlerts.push(alert);
                rowHasError = true;
              }
            }

            //B. Código Sucursal
            branchCode = parseInt(element[1] as string);
            if (isNaN(branchCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna B. El código de la sucursal no es válido.`;
              this.internalOrderAlerts.push(alert);
              rowHasError = true;
            }

            //C. Número Pedido Interno
            internalOrderNumber = parseFloat(element[2] as string);
            if (isNaN(internalOrderNumber)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna C. El número del pedido no es válido.`;
              this.internalOrderAlerts.push(alert);
              rowHasError = true;
            }

            //D. Número Alterno
            alterNumber = parseFloat(element[3] as string);

            //E. Fecha:
            const internalOrderDateString = element[4] as string;
            if (internalOrderDateString == null || internalOrderDateString == "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna E. El campo de fecha es obligatorio.`;
              this.internalOrderAlerts.push(alert);
              rowHasError = true;
            }
            //Convierte fecha de string a Date
            internalOrderDate = moment(internalOrderDateString, 'DD/MM/YYYY').toDate();
            if (!moment(internalOrderDateString, 'DD/MM/YYYY').isValid()) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna E. El campo de fecha no es válido.`;
              this.internalOrderAlerts.push(alert);
              rowHasError = true;
            }

            //F. Responsable
            responsible = element[5] as string;
            if (element[5] == null || element[5] == "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna F. El responsable no es válido.`;
              this.internalOrderAlerts.push(alert);
              rowHasError = true;
            } else {
              if (responsible.length > 250) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna F. El responsable supera el tamaño máximo de caracteres (250).`;
                this.internalOrderAlerts.push(alert);
                rowHasError = true;
              }
            }

            //G. Observación
            observation = element[6] as string;
            if (observation != null && observation.length > 250) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna G. El campo observación supera el tamaño máximo de caracteres (250).`;
              this.internalOrderAlerts.push(alert);
              rowHasError = true;
            }

            //H. Estado
            internalOrderState = parseFloat(element[7] as string);
            if (isNaN(internalOrderState)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna H. El estado del pedido no es válido.`;
              this.internalOrderAlerts.push(alert);
              rowHasError = true;
            } else {
              if (internalOrderState != InternalOrderEnums.open && internalOrderState != InternalOrderEnums.close && internalOrderState != InternalOrderEnums.annul) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna H. El estado del pedido debe ser valores como:\n1. Abierto\n2. Cerrado\n3. Anulado.`;
                this.internalOrderAlerts.push(alert);
                rowHasError = true;
              }
            }

            //I. Clase OM
            maintenanceOrderClass = parseFloat(element[8] as string);
            if (element[8] != null) {
              if (maintenanceOrderClass != ClassMaintenanceOrderEnum.enTaller &&
                maintenanceOrderClass != ClassMaintenanceOrderEnum.enSitio &&
                maintenanceOrderClass != ClassMaintenanceOrderEnum.programada
              ) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Fila ${counter}, Columna I. La clase de la orden de mantenimiento no es válida.`;
                this.internalOrderAlerts.push(alert);
                rowHasError = true;
              }
            }

            //J. Número OM
            maintenanceOrderNumber = parseFloat(element[9] as string);

            //K. Código Artículo
            articleCode = parseFloat(element[10] as string);
            if (isNaN(articleCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna K. El código del artículo no es válido.`;
              this.internalOrderAlerts.push(alert);
              rowHasError = true;
            }

            //L. Número Cotización
            quotationNumber = parseFloat(element[11] as string);

            //M. Urgente
            if (element[12] as string != "S" && element[12] as string != "N") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna M. El campo urgente debe ser valores como: S / N.`;
              this.internalOrderAlerts.push(alert);
              rowHasError = true;
            }
            swUrgent = element[12] as string === "S";

            //N. Cantidad
            quantity = parseFloat(element[13] as string);
            if (isNaN(quantity)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna N. El campo cantidad debe ser un valor numérico.`;
              this.internalOrderAlerts.push(alert);
              rowHasError = true;
            }

            if (!rowHasError) {
              row = new InternalOrderImportModel(counter, this.companyId, branchCode, internalOrderNumber, alterNumber, internalOrderDate, responsible, observation, internalOrderState,
                maintenanceOrderClass, maintenanceOrderNumber, articleCode, quotationNumber, swUrgent, quantity);
              rowsImport.push(row);
            } else {
              isOk = false;
            }
          });
          if (isOk && rowsImport.length > 0) {
            try {
              const response = await firstValueFrom(this.internalOrderService.importInternalOrder(rowsImport));
              this.loadPreInvoicingModel = response;
              this.internalOrderAlerts = response?.alerts ?? [];
              this.errorInternalOrder = response?.preInvoicingStateId;
              if (this.errorInternalOrder === 1) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con errores, puede exportarlos si lo desea.',
                  'ERROR');
              } else if (this.internalOrderAlerts.length > 0) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
              } else {
                this.visibleTxt = false;
                this.toastHandlerService.showToast('success', `La importación terminó exitosamente.`);
              }
              this.clearInputFile();
            } catch (error) {
              this.nameFile = 'Ningún archivo seleccionado.';
              console.error('Error al importar Pedidos Internos', error);
            }
          } else {
            this.errorInternalOrder = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea'
            );
          }
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No ha seleccionado ningún archivo.'
        });
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      companyId: {
        required: 'La compañía es obligatoria.',
        min: 'La compañía es obligatiria.',
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formImport.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  validateForm() {
    this.formImport = this.formBuilder.group({
      companyId: [0, [Validators.required, Validators.min(1)]],
    });
  }
}
